export default "__VITE_ASSET__UmhQwbR4__"